export class TenantService {

    public tenantId: string;
    public tenantName: string;
}
